export default "__VITE_ASSET__gBhfxEGN__"